import React, { useContext } from 'react'
import '../../../../../Portfolio_R/SummaryCharts/styles.scss'
import { useTranslation } from 'react-i18next';
import { useNumberFormatter } from '../../../../../../hooks/useNumberFormatter';
import HeaderExtended from '../../HeaderExtended';
import usePortfolioName from '../../../../../../hooks/usePortfolioName';
import { TagFilterContext } from '../../../../../../context/TagFilterContext';
import { TcpReportData } from '../typesExtendedReport';
import { useTcpMappedData } from './useTcpMappedData';
import CompositionProjectsCard from './components/CompositionProjectsCard';
import ApprovedIdbAmounts from './components/ApprovedIdbAmounts';
import CompositionWalletCard from './components/CompositionWalletCard';
import PendingCard from '../shared/PendingCard';
import TitlesAndValuesCard from '../shared/TitlesAndValuesCard';
import ReusableIcon from '../../shared/ReusableIcon';


export const gradientColors = [
    '#0b396e',
    '#3975c8',
    '#4fa0a5',
    '#f39f2e',
    '#ffd700',
    '#27BAC7',
    '#BE86D8',
    '#FA3938',
    '#91E2A1',
    '#F06D6D',
    '#538CFF',
    '#E58EB8',
    '#B1CBFF',
    '#D0DEF9',
];

interface TcpProps {
    data: TcpReportData | null | undefined;
    creationDate: string | Date;
    regions: any;
    myPortfolio?: string;
    countries?: string;
    filtersApplied?: any;
}
const ExtendedReportTcp: React.FC<TcpProps> = ({ data, creationDate, regions, myPortfolio, countries, filtersApplied }) => {
    const { t } = useTranslation();
    const { formatMillions } = useNumberFormatter();
    const portfolioName = usePortfolioName();
    const { labels } = useContext(TagFilterContext);
    const title = 'TCP'
    const mp = useTcpMappedData(data, gradientColors)
    if (!data || !mp) return null;

    const taxonomyData = [
        {
            title: t('one_pager_report.customer_support'),
            data: mp.fields.customerSupportPercent,
            units: "%"
        },
        {
            title: t('one_pager_report.support_loan'),
            data: mp.fields.loanPortfolioSupportPercent,
            units: "%"
        },
        {
            title: t('one_pager_report.research_and_dissemination'),
            data: mp.fields.researchDisseminationPercent,
            units: "%"
        }
    ]

    const participationData = [
        {
            title: t('one_pager_report.urd'),
            data: mp.fields.urdOffice,
        },
        {
            title: t('one_pager_report.8_contriues'),
            data: mp.fields.participant8Countries,
        },
        {
            title: t('one_pager_report.more_8_contriues'),
            data: mp.fields.participantPlus8Countries,
        }
    ]

    const executionData = [
        {
            title: t('one_pager_report.exceute_by_bank'),
            data: mp.fields.executedByBankPercent,
            units: "%"
        },
        {
            title: t('one_pager_report.exceute_by_agency'),
            data: mp.fields.executedByExecutingAgencyPercent,
            units: "%"
        }
    ]

    return (
        <>
            <div className='c-main'>
                <div style={{ margin: '0rem 1.5rem' }}>
                    <HeaderExtended
                        portfolioName={portfolioName}
                        filtersApplied={filtersApplied ?? labels}
                        creationDate={creationDate}
                        regions={regions}
                        countries={countries}
                        myPortfolio={myPortfolio}
                    />
                </div>

                <div className='content'>
                    <div className="section section-tcp content-background">
                        <header className="header-content mb-2">
                            <p>{t('one_pager_report.tcp_title')}</p>
                            <ReusableIcon
                                title={title}
                                color="#66B6B6"
                            />
                        </header>

                        <div className={`c-charts-tcp ${myPortfolio === "Global" ? "global-grid" : ""}`}>
                            <CompositionProjectsCard
                                t={t}
                                mp={mp}
                            />

                            <ApprovedIdbAmounts
                                mp={mp}
                                t={t}
                                formatMillions={formatMillions}
                            />

                            <CompositionWalletCard
                                t={t}
                                mp={mp}
                            />

                            <TitlesAndValuesCard
                                principalTitle={t('one_pager_report.taxonomy')}
                                generalData={taxonomyData}
                                styleContent="taxonomy"
                            />

                            <TitlesAndValuesCard
                                principalTitle={t('one_pager_report.participation')}
                                generalData={participationData}
                                styleContent="participation"
                            />

                            <TitlesAndValuesCard
                                principalTitle={t('one_pager_report.execution')}
                                generalData={executionData}
                                styleContent="execution"
                            />

                            <PendingCard
                                firstData={mp.fields.pendingLegalValidity}
                                firstTitle={t('one_pager_report.pending_legal_validity')}
                            />

                            <PendingCard
                                className="pending-legal"
                                firstData={mp.fields.projectsOverdueDisbursement}
                                firstTitle={t('one_pager_report.projects_with_deadlines')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExtendedReportTcp